import { AddressOption, LookupAddressSuggestion } from 'src/types/address';

export const parseSmartyResultToAddress = (
  result: LookupAddressSuggestion
): AddressOption => ({
  components: result,
  label: `${result.street_line} ${result.secondary} ${result.city} ${result.state} ${result.zipcode}`,
  value: `${result.street_line} ${result.secondary} ${result.city} ${result.state} ${result.zipcode}`,
});
